export class ChannelTestingTypeMapping {
    channelAssosiatedToDisease: string[];
    diseaseName: string;
}